import * as AssetDownload from 'bundles/ent-website/contentful/modules/MarketoFormModules/AssetDownload';
import * as CompanySizeLicenseCount from 'bundles/ent-website/contentful/modules/MarketoFormModules/CompanySizeLicenseCount';
import * as HiddenFields from 'bundles/ent-website/contentful/modules/MarketoFormModules/HiddenFields';

const onLoad = [HiddenFields.populateMarketoHiddenFields];
const beforeSubmit = [CompanySizeLicenseCount.concatSizeLicense];
const beforeSuccess = [AssetDownload.downloadAsset];

export { onLoad, beforeSubmit, beforeSuccess };
